import styled from "styled-components";

export const PCard  = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: row;
    padding: 10px 30px;
    min-height: 150px;
    margin: 10px;
    border-radius: 10px;
    /* box-shadow: 0px 2px 16px 1px rgba(0,0,0,0.2); */
    text-align: right;
    img{
        align-self: center;
        width: 80px;
        /* border: 1px solid gray; */
    box-shadow: 0px 2px 16px 1px rgba(0,0,0,0.2);

    }
    h2{
        font-size: 32px;
        align-self: center;
        font-weight: 600;
        margin: 0px;
    }
    p{
        margin: 0px;
    }
    span{
        
    }
    
    @media only screen and (max-width: 992px) {
        h2{
            font-weight: 600;
            font-size: 18px;
        }
        p{
            font-size: 14px;
        }
    }

`;

export const Card  = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 10px 30px;
    min-height: 150px;
    margin: 10px;
    border-radius: 10px;
    box-shadow: 0px 2px 16px 1px rgba(0,0,0,0.2);
    text-align: right;
    h2{
        font-weight: 600;
        font-size: 24px;
        letter-spacing: 1px;
    }
    p{
        color: gray;
    }
    span{
        
    }
    
    @media only screen and (max-width: 992px) {
        h2{
            font-weight: 600;
            font-size: 18px;
        }
        p{
            font-size: 14px;
        }
    }

`;